export type MTooltipBasicPosition = "top" | "bottom" | "left" | "right";

export interface MTooltipBasicProps {
  offset?: [number, number];
  position?: MTooltipBasicPosition;
}

export const mTooltipBasicDefaults = {
  offset: () => [0, 6] as [number, number],
  position: "bottom" as MTooltipBasicPosition,
} satisfies {
  offset: () => [number, number];
  position: MTooltipBasicPosition;
};
